import { request } from "store/api/organization/subscriptionGet/subscriptionGetActions";
import { useResource } from "./useResource";
import { hasAccess, resources, access } from "@p81-common/shell-core-js";

export function useSubscription() {
  return useResource(
    "subscriptionGet",
    request,
    hasAccess(resources.BILLING, access.READ)
  );
}
